import { EditOutlined } from "@ant-design/icons";
import { Button, ConfigProvider, Pagination, PaginationProps, Space, Switch, Table, TableColumnsType, Tooltip } from "antd"
import viVN from 'antd/locale/vi_VN';
import { DataTypeGeneralConfiguration } from "..";
import { getInfoMessagingProviderConfig, getInfoSmsConfig, getListSmsConfig, IGeneralConfiguration, InfoSmsConfig, IProvider, ISmsConfig, updateMessagingProviderConfig, updateSMSActiveConfig } from "../../../../api/generalConfiguration/generalConfigurationApi";
import { useEffect, useState } from "react";
import { dataPagination, getPermissionClass, getUserPermissions } from "../../../../until";
import useThrottle from "../../../../hook/useThrottle";
import useToast from "../../../../hook/useToast";
import { formatNumber } from "../../../../services/mixin";
import { NO_DATA, NO_VIEW } from "../../../../services/data";
import ModalCreateSMSProvider from "./Modal/ModalCreateSMSProvider";
import { getListSmsProvider } from "../../../../api/integrationProvider/integrationProvidersApi";
import ModalUpdateSMSProvider from "./Modal/ModalUpdateSMSProvider";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectorPermission } from "../../../../store/slices/permissionSlice";

interface PropSMS {
  listSmsConfig?: ISmsConfig[]
  type: number
  infoMessagingProviderConfig?: IGeneralConfiguration
  paginationTmp: number
  pagination: { current: number, pageSize: number, total: number }

  setPagination: (current: any) => void
  setPaginationTmp: (value: number) => void
  gInfoMessagingProviderConfig: (value: number) => void
  gListSmsConfig?: (pageNumber?: number, pageSize?: number) => void
}

const SMSGeneralConfiguration: React.FC<PropSMS> = ({
  listSmsConfig, type, infoMessagingProviderConfig, paginationTmp, pagination,

  gListSmsConfig, gInfoMessagingProviderConfig, setPaginationTmp, setPagination
}) => {

  const location = useLocation()
  const permissionSlice = useSelector(selectorPermission)
  const { add, edit, delete: isdelete, upload, download } = getUserPermissions(permissionSlice, location.pathname)

  const columns: TableColumnsType<ISmsConfig> = [
    {
      title: 'Hành động',
      dataIndex: '',
      key: 'action',
      render: (_: any, record: ISmsConfig) => (
        <Space size="middle">
          <div className="t-switch-block t-switch-block-sm">
            <Switch
              checked={Boolean(record.status)}
              onChange={() => uActiveMessagingProviderConfig(Number(record.idActive))}
            />
          </div>
          <EditOutlined
            className={` ${getPermissionClass(edit)} text-sm border-D9D9D9 p-5-px bg-white rounded-2`}
            onClick={() => handleUpdateSMS(Number(record.id))}
          />
        </Space>
      ),
    },
    {
      title: 'Brandname',
      dataIndex: 'brandName',
      key: 'brandName',
      render: (text, record, index) => (
        <div className="d-flex align-center network">
          <span className="neutral-gray-500">{text || NO_DATA}</span>
        </div>
      ),
    },
    {
      title: 'Số điện thoại để gửi',
      dataIndex: 'phoneNumber',
      key: 'phoneNumber',
      render: (text, record, index) => (
        <div className="d-flex align-center network">
          <span className="neutral-gray-500">{text || NO_DATA}</span>
        </div>
      ),
    },
    {
      title: 'Thương hiệu hãng xe',
      dataIndex: 'categories',
      key: 'categories',
      render: (text, record, index) => (
        <div className="d-flex align-center network">
          <span className="neutral-gray-500">{text || NO_DATA} </span>
        </div>
      ),
    },
    {
      title: 'Phạm vi hoạt động',
      dataIndex: 'units',
      key: 'units',
      render: (text, record, index) => (
        <div className="d-flex align-center network">
          <span className="neutral-gray-500">{text || NO_DATA}</span>
        </div>
      ),
    },
    {
      title: 'Nhà cung cấp',
      dataIndex: 'providerName',
      key: 'providerName',
      render: (text, record, index) => (
        <div className="d-flex align-center network">
          <span className="neutral-gray-500 w-200-px">{text || NO_DATA}</span>
        </div>
      ),
    },
    {
      title: 'Username',
      dataIndex: 'smtpUsername',
      key: 'smtpUsername',
      align: 'center',
      render: (smtpUsername) => (
        <Tooltip title={smtpUsername} >
          <span className='tooltip-an '>
            {/* {smtpUsername || NO_DATA} */}
            {NO_VIEW}
          </span>
        </Tooltip>

      ),
    },
    {
      title: 'Password',
      dataIndex: 'smtpPassword',
      key: 'smtpPassword',
      align: 'center',
      render: (smtpPassword) => (
        <Tooltip title={smtpPassword} >
          <span className='tooltip-an '>
            {/* {smtpPassword || NO_DATA} */}
            {NO_VIEW}
          </span>
        </Tooltip>


      ),
    },
    {
      title: 'Ngày kết nối',
      dataIndex: 'timestamp',
      key: 'timestamp',
      align: 'center',
      render: (value) => (
        <span className="neutral-gray-500">{(value) || NO_DATA}</span>
      )
    },
  ]
  const pushToast = useToast()
  const [openCreateSMS, setOpenCreateSMS] = useState(false)
  const [openEditSMS, setOpenEditSMS] = useState(false)

  const [isModalAddSMSProvider, setIsModalAddSMSProvider] = useState(false)
  const [isModalUpdateSMSProvider, setIsModalUpdateSMSProvider] = useState(false)

  const [listProvider, setListProvider] = useState<ISmsConfig[]>([])
  const [infoSmsConfig, setInfoSmsConfig] = useState<InfoSmsConfig>()

  //thiếu đổi từ API mục tiêu sang SMS
  // const glistProvider = async () => {
  //   const result = await getListSmsConfig()
  //   if (result?.status) {
  //     setListProvider(result.data)
  //   } else {
  //     pushToast(result?.message, "warning")
  //   }
  // }

  const gInfoSmsConfig = async (id: number) => {
    const result = await getInfoSmsConfig(id)
    if (result?.status) {
      setInfoSmsConfig(result.data)
    } else {
      pushToast(result?.message, "warning")
    }
  }


  const uActiveMessagingProviderConfig = useThrottle(async (id: number) => {
    const result = await updateSMSActiveConfig(id);
    if (result?.status) {
      gListSmsConfig?.(paginationTmp, pagination.pageSize)
      pushToast(result.message, "success", 2000)
    } else {
      pushToast(result.message, "error", 2000)

    }
  }, 2000)



  const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    setPaginationTmp(pageNumber);
    setPagination((prev: any) => ({ ...prev, current: pageNumber, pageSize }))
    gListSmsConfig?.(pageNumber, pageSize)
  }


  const handleUpdateSMS = (id: number) => {
    if (!id) return;
    gInfoSmsConfig(id)
    setIsModalUpdateSMSProvider(true)
  }

  const onSubmitFormModalAdd = (iSsuccess: boolean, message?: string) => {
    if (iSsuccess) {
      setIsModalAddSMSProvider(false)
      pushToast(message, "success")
      gListSmsConfig?.()
    } else {
      pushToast(message, "error")
    }
  }

  const onSubmitFormModalUpdate = (iSsuccess: boolean, message?: string) => {
    if (iSsuccess) {
      setIsModalUpdateSMSProvider(false)
      pushToast(message, "success")
      gListSmsConfig?.()
    } else {
      pushToast(message, "error")
    }
  }


  return (
    <div className="custom-page-css flex flex-col flex-1 h-full gap-18-px pt-2">


      <ModalCreateSMSProvider
        isOpen={isModalAddSMSProvider}
        onSubmitFormModal={onSubmitFormModalAdd}
        closeModal={() => setIsModalAddSMSProvider(false)}
      />

      <ModalUpdateSMSProvider
        isOpen={isModalUpdateSMSProvider}
        infoSmsConfig={infoSmsConfig}

        onSubmitFormModal={onSubmitFormModalUpdate}
        closeModal={() => setIsModalUpdateSMSProvider(false)}
      />

      <div className="d-flex align-center justify-between">
        <span className="font-medium fsz-16 lh-24">Thông tin tích hợp</span>

        <div className="custom-page-css flex gap-2">
          {/* <Button className=" custom-page-css border rounded px-2"
            onClick={() => setIsModalSupplierManagement(true)}
          >
            <span>Quản lý nhà cung cấp</span>
          </Button> */}
          <Button
            // className="rounded-6-px h-8 w-83-px text-white bg-1890FF border-none text-sm"
            className={` ${getPermissionClass(add)}`}
            type="primary"
            onClick={() => setIsModalAddSMSProvider(true)}
          >
            Tạo mới
          </Button>
        </div>
      </div>
      <div className="custom-page-css flex flex-col flex-1 justify-between ">
        <Table
          columns={columns}
          dataSource={listSmsConfig}
          showSorterTooltip={false}
          className="rs-table notification-fees-table "
          pagination={false}
          scroll={{ x: 'max-content' }}
        />


      </div>
      <div className="custom-page-css mt-auto">
        <ConfigProvider locale={viVN}>
          <div className="pagination-block">
            <Pagination
              showSizeChanger
              current={paginationTmp}
              pageSize={pagination.pageSize}
              total={pagination.total}
              itemRender={(page, type, originalElement) => {
                // Chỉ custom khi là nút số trang
                if (type === 'page') {
                  return <span>{formatNumber(page)}</span>;
                }
                // prev / next / jump-prev / jump-next giữ nguyên
                return originalElement;
              }}
              showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize, paginationTmp).totalPage} trang`}
              className='rs-pagination'
              onChange={onPaginationChange}

            />
          </div>
        </ConfigProvider>
      </div>
    </div>
  )
}
export default SMSGeneralConfiguration
